module.exports = function() {
  return new Worker(__webpack_public_path__ + "4e4e1e191d5798ee385c.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader/dist/cjs.js!./~/pdfjs-dist/build/pdf.worker.js
// module id = 2299
// module chunks = 2